import { db, Timestamp } from '@/firebase.js'
import { firestoreAction } from 'vuexfire'
import { newId } from '@/utils'

const getDefaultState = () => {
  return {
    data: [],
    ref: ''
  }
}

const state = getDefaultState()

const getters = {
  data(state) {
    return { ...state.data }
  },
  ref(state) {
    return state.ref
  },
  reports(state) {
    return Object.assign({}, ...state.data.map(i => ({ [i.id]: i })))
  }
}

const actions = {
  bindStore: firestoreAction(
    ({ bindFirestoreRef, commit, state }, { storeId }) => {
      commit(
        'setRef',
        db
          .collection('stores')
          .doc(storeId)
          .collection('notifications')
      )
      return bindFirestoreRef('data', state.ref)
    }
  ),
  unbindStore: firestoreAction(({ unbindFirestoreRef }) => {
    unbindFirestoreRef('data')
  }),
  create: async function({ getters }, payload) {
    // when invoice doc is created in firestore,
    // server sends the email per email object
    let id = newId()
    let data = {
      ...payload,
      date: Timestamp.now(),
      createdAt: Timestamp.now(),
      status: 'open',
      completed: false,
      tax: 0,
      fees: 0,
      totalCost: 0,
      invoiceNumber: null,
      completedAt: null,
      completedBy: null,
      id
    }
    console.log('notifications/create', id, data)
    return getters.ref
      .doc(id)
      .set(data, { merge: true })
      .then(() => {
        return id
      })
      .catch(err => {
        return err
      })
  },
  delete: async function({ dispatch }, id) {
    console.log('notifications/delete', id)
    if (!id) throw new Error('No ID provided.')
    return dispatch('updateItem', { id, data: { status: 'deleted' } })
  },
  updateItem({ getters }, { id, data }) {
    console.log('notifications/updateItem', id, data)
    return getters.ref.doc(id).update(data)
  },
  resetStoreState({ commit }) {
    commit('resetState', null)
  }
}

const mutations = {
  setRef(state, ref) {
    state.ref = ref
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  }
}

const notifications = {
  namespaced: true,

  state,
  getters,
  mutations,
  actions
}

export default notifications
